module.exports = __webpack_public_path__ + "img/lb.fdf7e772.svg";